import { API_URL } from "../../../constants/urlConstants";
import { APIError, handleAPIError } from "../../common/errorHandler";
import { baseUrl, getApiAsyn, basePYUrl, getPythonApiAsyn } from "../../PostAPI";
import axios from "axios";
import Cookies from "universal-cookie";
import { downloadBlob } from "../../utils/download";
import { extractData } from "../../utils";
const cookies = new Cookies();

const dataExportApi = (url, payload) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "text/csv",
      authorization: cookies.get("authorization"),
    },
    responseType: "blob",
  };
  return axios.post(basePYUrl + url, payload, config);
};

export const generateReport = async (payload) => {
  const from = new Date(payload.transactions_from);
  const to = new Date(payload.transactions_to);
  if (from > to) {
    return {
      isError: false,
      message: "Start date cannot be after end date.",
      severity: "info",
    };
  }
  const trns_url = API_URL.REPORT.TRANSACTION_REPORT_GENERATE;
  const ifta_url = API_URL.REPORT.IFTA_REPORT_GENERATE;
  try {
    let result = await dataExportApi(payload?.report === "transactions" ?  trns_url : ifta_url, payload);
    if (result?.error) {
      throw new APIError(result);
    }
    const disposition = result.headers["content-disposition"];
    let fileName = "report.pdf";
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        fileName = match[1];
      }
    }
    const fileSize = Number(result.headers["content-length"] || 0);
    if (fileSize < 100) {
      // empty report
      return {
        isError: false,
        message: "No report found for the given date range.",
        severity: "info",
      };
    }
    // download report
    downloadBlob(result.data, fileName, payload?.format);
    return {
      isError: false,
      message: "Report generated successfully!",
      severity: "success",
    };
  } catch (error) {
    console.error(error);
    return {
      isError: true,
      message: "Error generating report. Please try again.",
      severity: "error",
    };
  }
};

export const getCustomers = async () => {
  const url = API_URL.REPORT.GET_CUSTOMERS;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.type === "error") {
      throw new APIError(result);
    }
    return result?.customers;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
